import { BankAccountDetails } from '../../../../pages/AddNewGigPage/PaymentSetupPage/PaymentSetupPage';
import upiIcon from  '../../../../assets/images/AddNewGigPage/upi-icon.png';
import { PaymentInterface } from '../../../../Models/Seller';
import { AcceptPaymentMethodEnum } from '../../../../enums/AcceptPaymentMethodEnum';
import { Box, Typography } from '@mui/material';
import GGButton from '../../../CommonComponents/GGButton/GGButton';
import { AccountBalance, DeleteOutline, Edit } from '@mui/icons-material';

const emptyBankAccount: BankAccountDetails = {
  accountNumber: "",
  bankIFSC: "",
  holderName: "",
  bankName: ""
}

const parseUpiId = (paymentDetails: string): string => {
  try {
    return JSON.parse(paymentDetails)
  } catch {
    return paymentDetails
  }
}

const parseBankAccount = (paymentDetails: string): BankAccountDetails => {
  try {
    return JSON.parse(paymentDetails)
  } catch {
    return emptyBankAccount
  }
}

const SellerPaymentMethodItem = ({ 
  paymentMethod, 
  deleteItem, 
  editItem, 
  setAsDefault,
  editLoading = false
}: { 
  paymentMethod: PaymentInterface, 
  deleteItem: Function,
  editItem: Function,
  setAsDefault: Function,
  editLoading?: boolean
}) => {

  const defaultSelected = paymentMethod.isDefault ?? false

  const upiId = paymentMethod.paymentMethod === AcceptPaymentMethodEnum.UPI
    ? parseUpiId(paymentMethod.paymentDetails)
    : ""

  const bankAccount = paymentMethod.paymentMethod === AcceptPaymentMethodEnum.BankAccount
    ? parseBankAccount(paymentMethod.paymentDetails)
    : emptyBankAccount

  const handleItemClick = () => {
    if (!defaultSelected) {
      setAsDefault()
    }
  }

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  return (

    <div 
      className={defaultSelected ? "available-method-list-item default-selected" : "available-method-list-item"}
      onClick={handleItemClick}
      style={{ 
        cursor: defaultSelected ? 'default' : 'pointer',
        transition: 'all 0.3s ease-in-out'
      }}
    >

      <div className="payment-method-type-section">
        {paymentMethod.paymentMethod === AcceptPaymentMethodEnum.UPI && <Box className="instrument-upi-icon"> <img src={upiIcon} alt="UPI" /> </Box>}
        {paymentMethod.paymentMethod === AcceptPaymentMethodEnum.BankAccount && <Box className="instrument-bank-icon-segment"> <AccountBalance sx={{ marginRight: "10px" }} fontSize="medium" /> {"Bank Account"} </Box>}
      </div>

      <Box className="payment-details-section">
        {paymentMethod.paymentMethod === AcceptPaymentMethodEnum.UPI && <Typography fontSize={"20px"}> {upiId} </Typography>}
        {paymentMethod.paymentMethod === AcceptPaymentMethodEnum.BankAccount && <Typography fontSize={"20px"}> {bankAccount.accountNumber} </Typography>}
      </Box>

      <div className="button-section" onClick={handleButtonClick}>
        {(defaultSelected) && <div className="default-tag"> Default </div>}
        <GGButton 
          startIcon={<Edit />} 
          onClick={() => editItem()}
          disabled={editLoading}
        >
          Edit
        </GGButton>

        <GGButton btnColor="red" startIcon={<DeleteOutline />} onClick={() => deleteItem()} disabled ={paymentMethod.isDefault}>
          Delete
        </GGButton>
      </div>

    </div>
  )
}

export default SellerPaymentMethodItem